import Result from "../components/Result";
import Footer from "../components/layout/Footer";
import Header from "../components/layout/Header";

export default function ResultPage() {
  return (
    <div className="App bg-gray-100 min-h-screen flex flex-col">
        <Header />
        <Result />
        <Footer />
    </div>
  );
}